import React, { useEffect, useState } from 'react';
import './messageSuccess.css'; // 👈 create this file below

export default function SuccessMessage({ onReset }: { onReset: () => void }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`success-container ${show ? 'show' : ''}`}>
      <div className="success-card">
        <div className="checkmark">
          <svg viewBox="0 0 24 24">
            <path
              fill="none"
              stroke="#34c759"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h2>Message Delivered!</h2>
        <p>Thanks for reaching out, I’ll get back to you as soon as possible</p>
        <button type="button" onClick={onReset}>
          Send Another Message
        </button>
      </div>
    </div>
  );
}
